import * as React from 'react'

import FormDropdown from 'embed/components/FormDropdown'
import {
  DropdownItem,
  HAVEN_SIMPLE_UUID_DEV,
  HAVEN_SIMPLE_UUID_PROD,
  HAVEN_TERM_UUID_DEV,
  HAVEN_TERM_UUID_PROD,
  HavenSimpleCoverageAmount,
  HavenSimpleCoverageAmounts,
  HavenTermCoverageAmount,
  HavenTermCoverageAmounts,
  HavenTermDuration,
  HavenTermDurations,
  LifeInsuranceCoverageAmount,
  LifeInsuranceCoverageAmounts,
  LifeInsuranceDuration,
  LifeInsuranceDurations,
} from 'embed/constants'
import { formatCurrency } from 'embed/utils'
import { LifeInsuranceOffer } from 'embed/constants/models'

const styles = require('./styles')

interface Props {
  coverageAmount?: number
  duration?: number
  offer?: LifeInsuranceOffer
  onCoverageAmountChange: (fieldName: string, value: string) => void
  onDurationChange: (fieldName: string, value: string) => void
}

const COVERAGE_AMOUNT_OPTIONS: DropdownItem<LifeInsuranceCoverageAmount>[] = LifeInsuranceCoverageAmounts.map(
  (value) => ({ label: `$${formatCurrency(value)}`, value }),
)

const HAVEN_TERM_COVERAGE_AMOUNT_OPTIONS: DropdownItem<HavenTermCoverageAmount>[] = HavenTermCoverageAmounts.map(
  (value) => ({ label: `$${formatCurrency(value)}`, value }),
)

const HAVEN_SIMPLE_COVERAGE_AMOUNT_OPTIONS: DropdownItem<HavenSimpleCoverageAmount>[] = HavenSimpleCoverageAmounts.map(
  (value) => ({ label: `$${formatCurrency(value)}`, value }),
)

const DURATION_OPTIONS: DropdownItem<LifeInsuranceDuration>[] = LifeInsuranceDurations.map((value) => ({
  label: `${value} years`,
  value,
}))

const HAVEN_TERM_DURATION_OPTIONS: DropdownItem<HavenTermDuration>[] = HavenTermDurations.map((value) => ({
  label: `${value} years`,
  value,
}))

const DropdownStyles = {
  dropDown: '',
  dropDownLabel: styles.dropdownLabel,
  fieldError: '',
}

export const CustomizeForm: React.SFC<Props> = ({
  coverageAmount,
  duration,
  onCoverageAmountChange,
  onDurationChange,
  offer,
}) => {
  const renderCoverageAmount = () =>
    offer?.partner.uuid === HAVEN_TERM_UUID_DEV || offer?.partner.uuid === HAVEN_TERM_UUID_PROD
      ? HAVEN_TERM_COVERAGE_AMOUNT_OPTIONS
      : offer?.partner.uuid === HAVEN_SIMPLE_UUID_DEV || offer?.partner.uuid === HAVEN_SIMPLE_UUID_PROD
      ? HAVEN_SIMPLE_COVERAGE_AMOUNT_OPTIONS
      : COVERAGE_AMOUNT_OPTIONS

  const renderCoverageDuration = () =>
    offer?.partner.uuid === HAVEN_TERM_UUID_DEV ||
    offer?.partner.uuid === HAVEN_TERM_UUID_PROD ||
    offer?.partner.uuid === HAVEN_SIMPLE_UUID_DEV ||
    offer?.partner.uuid === HAVEN_SIMPLE_UUID_PROD
      ? HAVEN_TERM_DURATION_OPTIONS
      : DURATION_OPTIONS

  return (
    <div className={styles.container}>
      <FormDropdown
        containerClass={styles.dropdownContainer}
        items={renderCoverageAmount()}
        label="Coverage Amount"
        onChange={onCoverageAmountChange}
        startingValue={coverageAmount}
        styles={DropdownStyles}
      />
      <FormDropdown
        containerClass={styles.dropdownContainer}
        items={renderCoverageDuration()}
        label="Duration"
        onChange={onDurationChange}
        startingValue={duration}
        styles={DropdownStyles}
      />
    </div>
  )
}
